export const GET_CUSTOM_REPORT = 'GET_CUSTOM_REPORT';
export const GET_CUSTOM_REPORT_CONFIG = 'GET_CUSTOM_REPORT_CONFIG';
